import React, { useState } from 'react';
import * as Sentry from "@sentry/react";
import useScript from '../hooks/useScript';
import {
  concatenateStreetNumberAndStreet,
  getValueFromGoogleMapsAddress,
} from '../services/googleMaps';

export default function GoogleMaps(props) {
    const googleMapContainer = React.createRef();
    const initialState = {
      isLoading: true,
      error: '',
      hasAttemptedToInitMap: false,
      address: props.address || ''
    }
    const [state, setState] = useState(initialState);

    useScript(`https://maps.googleapis.com/maps/api/js?key=${props.googleMapsApiKey}&libraries=places&callback=handleInitGoogleMap`);
    

    window.handleInitGoogleMap = function() {
        console.log('LOADED');
        if(!!window.google && !!window.google.maps) {
            console.log("window.google.maps has loaded");
        } else {
            Sentry.captureMessage("Google Maps API has not loaded");
            setState({...state, error:"Google Maps API could not load."});
        }
        console.log(window.google);
        setState({
          ...state,
          isLoading: false
        });
        initMap();
    }

    function initMap() {
        const google = window.google;
        if (!!google) {
          const map = new google.maps.Map(googleMapContainer.current, {
            center: { lat: props.lat || 36.7857263, lng: props.lng || -119.9346459 },
            zoom: props.zoom || 6,
            mapTypeId: 'satellite',
            tilt: 0
          });
          const input = document.getElementById("pac-input");
          const options = {
            origin: map.getCenter(),
            componentRestrictions: { country: "us" },
            strictBounds: false,
            fields: ["formatted_address", "address_components", "geometry", "name"],
            types: ["address"],
            address: props.address || ''
          };
          const autocomplete = new google.maps.places.Autocomplete(input, options);
          // Bind the map's bounds (viewport) property to the autocomplete object,
          // so that the autocomplete requests use the current map bounds for the
          // bounds option in the request.
          autocomplete.bindTo("bounds", map);
          const infowindow = new google.maps.InfoWindow();
          const infowindowContent = document.getElementById("infowindow-content");
          infowindow.setContent(infowindowContent);
    
          const markerOptions = {
            map,
            anchorPoint: new google.maps.Point(0, -29),
            draggable: true
          }
          if (!!props.lat && props.lng) {
            markerOptions['position'] = { lat: props.lat, lng: props.lng }
          }
          const marker = new google.maps.Marker(markerOptions);
    
          marker.addListener("dragend", () => {
            console.log("dragend");
            const position = marker.getPosition();
            if (!!position) {
              const lat = position.lat();
              const lng = position.lng();
              if (!!lat && !!lng) {
                props.updateLocation({
                  lat,
                  lng
                });
              }
            }
          });
    
          autocomplete.addListener("place_changed", () => {
            infowindow.close();
            marker.setVisible(false);
            const place = autocomplete.getPlace();
    
            if (!place.geometry || !place.geometry.location) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.
              window.alert("No details found for input: '" + place.name + "'");
              return;
            }
    
            // If the place has a geometry, then present it on a map.
            if (place.geometry.viewport) {
              map.fitBounds(place.geometry.viewport);
              map.setZoom(30);
            } else {
              console.log("setting zoom");
              map.setCenter(place.geometry.location);
              map.setZoom(30);
            }
            marker.setPosition(place.geometry.location);
            marker.setVisible(true);
            infowindowContent.children["place-name"].textContent = place.name;
            infowindowContent.children["place-address"].textContent = place.formatted_address;
            infowindow.open(map, marker);
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            const address = place.formatted_address;

            const zipFromGoogleMaps = getValueFromGoogleMapsAddress("zip", place.address_components);
            const streetNumberFromGoogleMaps = getValueFromGoogleMapsAddress("street number", place.address_components);
            const streetFromGoogleMaps = getValueFromGoogleMapsAddress("street", place.address_components);
            const cityFromGoogleMaps = getValueFromGoogleMapsAddress("city", place.address_components);
            const stateFromGoogleMaps = getValueFromGoogleMapsAddress("state", place.address_components);
            const countryFromGoogleMaps = getValueFromGoogleMapsAddress("country", place.address_components);

            const zoom = map.getZoom();
            const addressData = {
              address,
              city: cityFromGoogleMaps,
              street: concatenateStreetNumberAndStreet(streetNumberFromGoogleMaps, streetFromGoogleMaps),
              state: stateFromGoogleMaps,
              country: countryFromGoogleMaps,
              zipCode: zipFromGoogleMaps,
              lat,
              lng,
              zoom,
              hasEdits: true
            }
            setState(prevState => ({
              ...prevState,
              address,
              zipFromGoogleMaps,
              lat,
              lng,
              zoom
            }));
            props.updateLocation(addressData);
          });
        } else {
          return <p className="error">We're sorry, it looks like there has been an error.  Please reach out to support.  Thank you!</p>;
        }
      }

    function handleChange(e) {
      setState({
        ...state,
        [e.target.name]: e.target.value
      });
      if(!!e.target.name && e.target.name === "address") {
        props.updateLocation({address});
      }
    }

    const {
      error,
      address
    } = state;

    if(error) {
        return (
            <div>
                <p>Error.  Please reach out to support for assistance.  Sorry for the inconvenience!</p>
            </div>
        );
    } else {
        return (
          <div style={{marginBottom: "16px"}}>
            <p className="mt-3 mb-3 p-0-4 text-medium">Address</p>
            <div className='reset'>
              <input
                  id="pac-input"
                  className='styled-input text-small text-start'
                  placeholder="Enter a location..."
                  value={address}
                  name="address"
                  onChange={handleChange}
              />
                <div ref={googleMapContainer} id="googleMap" style={{width:"100%",height:"400px"}}></div>
                <div id="infowindow-content">
                  <span id="place-name" className="title"></span><br />
                  <span id="place-address"></span>
              </div>
            </div>
          </div>
        )
    }
}
